// ===== MONKEWORLD APP — Carousels, Video =====

(function () {
  'use strict';

  // ===== HERO PRODUCT CAROUSEL (supports mixed img/video slides) =====
  function initHeroProductCarousel() {
    var slides = document.querySelectorAll('.hero-slide');
    var dots = document.querySelectorAll('.hero-dot');
    if (slides.length < 2) return;

    var current = 0;
    var timer = null;

    function pauseSlideVideo(slide) {
      if (slide.tagName === 'VIDEO') {
        slide.pause();
      }
    }

    function playSlideVideo(slide) {
      if (slide.tagName === 'VIDEO') {
        // Lazy-load: the file is only requested the first time this slide shows
        if (slide.dataset.src && !slide.getAttribute('src')) {
          slide.src = slide.dataset.src;
          slide.load();
        }
        slide.muted = true;
        slide.play().catch(function () {});
      }
    }

    function goTo(index) {
      pauseSlideVideo(slides[current]);
      slides[current].classList.remove('active');
      dots[current].classList.remove('active');
      current = index;
      slides[current].classList.add('active');
      dots[current].classList.add('active');
      playSlideVideo(slides[current]);
    }

    function advance() {
      goTo((current + 1) % slides.length);
    }

    function startAutoplay() {
      clearInterval(timer);
      timer = setInterval(advance, 4000);
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(parseInt(dot.dataset.slide));
        startAutoplay();
      });
    });

    // Arrow buttons
    var prevBtn = document.querySelector('[data-hero-prev]');
    var nextBtn = document.querySelector('[data-hero-next]');
    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        goTo((current - 1 + slides.length) % slides.length);
        startAutoplay();
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        goTo((current + 1) % slides.length);
        startAutoplay();
      });
    }

    startAutoplay();
  }

  // ===== LAZY VIDEO: fetch near the viewport, play only while visible =====
  // Every card video ships with preload="none", a poster frame and data-src.
  // Nothing downloads until the card is within 400px of the viewport, and a
  // video only plays while at least a third of it is on screen.
  function initLazyVideos() {
    var videos = Array.prototype.slice.call(document.querySelectorAll('video[data-src]:not([data-hero-video])'));
    if (!videos.length) return;

    function load(video) {
      if (video.dataset.loaded) return;
      video.dataset.loaded = '1';
      video.src = video.dataset.src;
      video.load();
    }

    if (!('IntersectionObserver' in window)) {
      videos.forEach(function (v) { load(v); if (v.hasAttribute('data-autoplay')) v.play().catch(function () {}); });
      return;
    }

    var near = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        load(entry.target);
        near.unobserve(entry.target);
      });
    }, { rootMargin: '400px 0px' });

    var visible = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var video = entry.target;
        if (entry.isIntersecting) {
          load(video);
          video.play().catch(function () {});
        } else {
          video.pause();
          if (!video.muted) setMuted(video, true);
        }
      });
    }, { threshold: 0.35 });

    function setMuted(video, muted) {
      video.muted = muted;
      var wrap = video.closest('.vid-wrap');
      if (!wrap) return;
      wrap.classList.toggle('is-unmuted', !muted);
      var btn = wrap.querySelector('[data-vid-sound]');
      if (btn) {
        btn.setAttribute('aria-pressed', muted ? 'false' : 'true');
        btn.setAttribute('aria-label', muted ? 'Turn sound on' : 'Turn sound off');
      }
    }

    function toggleSound(video) {
      var unmute = video.muted;
      if (unmute) {
        // Only one video with sound at a time
        videos.forEach(function (other) { if (other !== video && !other.muted) setMuted(other, true); });
      }
      setMuted(video, !unmute);
      if (unmute) video.play().catch(function () {});
    }

    videos.forEach(function (video) {
      near.observe(video);
      if (video.hasAttribute('data-autoplay')) visible.observe(video);
      var wrap = video.closest('.vid-wrap');
      var btn = wrap && wrap.querySelector('[data-vid-sound]');
      if (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          toggleSound(video);
        });
      }
      video.addEventListener('click', function () { toggleSound(video); });
    });
  }

  // ===== AUTO-SCROLL CAROUSELS =====
  function initAutoScroll() {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var tracks = document.querySelectorAll('.vs-track, .ugc-track');

    tracks.forEach(function (track) {
      var paused = false;
      var onScreen = false;
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          onScreen = entries[0].isIntersecting;
          lastTime = 0;
        }, { threshold: 0.05 }).observe(track);
      } else {
        onScreen = true;
      }
      var resumeTimer = null;
      var lastTime = 0;
      var speed = 0.04; // px per ms

      track.style.scrollSnapType = 'none';

      function step(timestamp) {
        if (lastTime === 0) lastTime = timestamp;
        var delta = timestamp - lastTime;
        lastTime = timestamp;

        if (onScreen && !paused && delta < 100) {
          track.scrollLeft += speed * delta;
          if (track.scrollLeft >= track.scrollWidth - track.clientWidth - 2) {
            track.scrollLeft = 0;
          }
        }
        requestAnimationFrame(step);
      }

      // Pause the auto-scroll while the visitor interacts. Snap type is left
      // alone: toggling it on the fly makes the track jump to the nearest card,
      // which scrolled the tapped video out of view (and re-muted it).
      function pauseScroll() {
        paused = true;
        lastTime = 0;
        clearTimeout(resumeTimer);
        resumeTimer = setTimeout(function () {
          paused = false;
          lastTime = 0;
        }, 6000);
      }

      track.addEventListener('pointerdown', pauseScroll);
      track.addEventListener('touchstart', pauseScroll, { passive: true });
      track.addEventListener('wheel', pauseScroll, { passive: true });

      requestAnimationFrame(step);
    });
  }

  // ===== FOUNDER VIDEO (click-to-play facade) =====
  function initFounderVideo() {
    var facade = document.getElementById('founderFacade');
    var video = document.getElementById('founderVideo');
    if (!facade || !video) return;

    facade.addEventListener('click', function () {
      if (video.dataset.src && !video.getAttribute('src')) {
        video.src = video.dataset.src;
        video.load();
      }
      facade.style.display = 'none';
      video.style.display = 'block';
      video.play().catch(function () {});
    });
  }

  // ===== POPUP SHARED STATE (prevent stacking) =====
  var popupOpen = false;

  function isAnyPopupOpen() {
    return popupOpen;
  }

  function openPopup(popup) {
    popupOpen = true;
    popup.classList.add('visible');
    popup.setAttribute('aria-hidden', 'false');
  }

  function closePopup(popup) {
    popup.classList.remove('visible');
    popup.setAttribute('aria-hidden', 'true');
    popupOpen = false;
  }

  // ===== EMAIL CAPTURE POPUP (20s delay, once per visitor, email-gated code) =====
  function initEmailPopup() {
    var popup = document.getElementById('emailPopup');
    if (!popup || localStorage.getItem('mw_email_shown')) return;

    var step1 = document.getElementById('emailStep1');
    var step2 = document.getElementById('emailStep2');

    setTimeout(function () {
      if (isAnyPopupOpen()) return;
      openPopup(popup);
      localStorage.setItem('mw_email_shown', '1');
    }, 20000);

    popup.querySelectorAll('[data-popup-close]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        if (btn.tagName !== 'A') e.preventDefault();
        closePopup(popup);
      });
    });

    var form = popup.querySelector('[data-email-form]');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        // Show code after email submitted
        if (step1) step1.style.display = 'none';
        if (step2) step2.style.display = 'block';
      });
    }
  }

  // ===== EXIT-INTENT POPUP (once per session, email-gated code) =====
  function initExitIntent() {
    var popup = document.getElementById('exitPopup');
    if (!popup || sessionStorage.getItem('mw_exit_shown')) return;

    var step1 = document.getElementById('exitStep1');
    var step2 = document.getElementById('exitStep2');
    var shown = false;

    function showExit() {
      if (shown || isAnyPopupOpen()) return;
      shown = true;
      sessionStorage.setItem('mw_exit_shown', '1');
      openPopup(popup);
    }

    // Desktop only: mouseleave top of viewport
    if (window.innerWidth >= 768) {
      document.addEventListener('mouseleave', function (e) {
        if (e.clientY <= 0) showExit();
      });
    }

    popup.querySelectorAll('[data-exit-close]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        if (btn.tagName !== 'A') e.preventDefault();
        closePopup(popup);
      });
    });

    var form = popup.querySelector('[data-exit-form]');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (step1) step1.style.display = 'none';
        if (step2) step2.style.display = 'block';
      });
    }
  }

  // ===== INIT =====
  initHeroProductCarousel();
  initLazyVideos();
  initAutoScroll();
  initFounderVideo();
  initEmailPopup();
  initExitIntent();
})();
